import type { Shell } from './ui/shell';

/** Shell singleton shared by views (set once in main.ts). */
export let shell: Shell;
export const setShell = (s: Shell): void => {
  shell = s;
};
